import { Action } from 'redux';

import { ExplorableItemType } from '../../../ts/models/ContentType';
import {
  ContentTypeFilterSelected,
  FilterContentType,
  ShowContentTypes,
  ToggleShowWorkbooksAsViews,
} from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface ContentTypeFilterSelectedAction extends Action {
  contentTypes: ReadonlyArray<ExplorableItemType>;
  clearAndSet: boolean;
}

export function contentTypeFilterSelected(contentTypes: ReadonlyArray<ExplorableItemType>, clearAndSet: boolean): ContentTypeFilterSelectedAction {
  return {
    type: ContentTypeFilterSelected,
    contentTypes,
    clearAndSet
  };
}

export interface FilterContentTypeAction extends Action {
  contentTypes: ReadonlyArray<ExplorableItemType>;
}

export function filterContentType(contentTypes: ReadonlyArray<ExplorableItemType>): FilterContentTypeAction {
  return {
    type: FilterContentType,
    contentTypes
  };
}

export const isFilterContentTypeAction = isActionFactory<FilterContentTypeAction>(FilterContentType);


export interface ShowContentTypesAction extends Action {
  contentTypes: ReadonlyArray<ExplorableItemType>;
}

export function showContentTypes(contentTypes: ReadonlyArray<ExplorableItemType>): ShowContentTypesAction {
  return {
    type: ShowContentTypes,
    contentTypes
  };
}

export const isShowContentTypesAction = isActionFactory<ShowContentTypesAction>(ShowContentTypes);


export interface ToggleShowWorkbooksAsViewsAction extends Action {
  showWorkbooksAsViews: boolean;
}

export function toggleShowWorkbooksAsViews(showWorkbooksAsViews: boolean): ToggleShowWorkbooksAsViewsAction {
  return {
    type: ToggleShowWorkbooksAsViews,
    showWorkbooksAsViews
  };
}

export const isToggleShowWorkbooksAsViewsAction = isActionFactory<ToggleShowWorkbooksAsViewsAction>(ToggleShowWorkbooksAsViews);
